'use client'
import { useViewContext } from '../../../../context/ViewContext/ViewContext.js';
import { hasPendingMfaAction } from '../../../../shared/utils/functions/hasPendingMfaAction/hasPendingMfaAction.js';
import { useUserCoalesced } from '../../../../store/state/user/user.js';
import '@dynamic-labs/utils';
import '../../../constants/values.js';
import '@dynamic-labs/sdk-api-core';
import '../../../../store/state/projectSettings/projectSettings.js';
import { mfaViewsThatPreventModalClose, viewsThatPreventModalClose, viewsThatHideCloseButton } from '../../../constants/authViewLayoutChecks.js';

const useAllowClose = () => {
    const { view } = useViewContext();
    const user = useUserCoalesced();
    const isMfaPreventingClose = user &&
        hasPendingMfaAction(user) &&
        mfaViewsThatPreventModalClose.includes(view.type);
    const allowsClosing = !isMfaPreventingClose && !viewsThatPreventModalClose.includes(view.type);
    const showCloseButton = allowsClosing && !viewsThatHideCloseButton.includes(view.type);
    return {
        /**
         * Whether user can close the current view
         */
        allowsClosing,
        /**
         * Whether the close button should be shown.
         * Even if the view allows closing, the close button may still be hidden.
         */
        showCloseButton,
    };
};

export { useAllowClose };
